// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3xJel","filesListContainer":"PosDisputesFiles_filesListContainer__1kzKp","filesButton":"PosDisputesFiles_filesButton__1LIYb"};